import { ShellConfig } from 'ams-portal-shell';

let cachedConfig: ShellConfig = {} as ShellConfig;

export const setConfig = (config: ShellConfig) => {
  cachedConfig = config;
};

const config = () => cachedConfig;

export default config;
